import React, {useEffect, useState} from 'react';
import {styled} from '@mui/material/styles';
import {Box, BoxProps} from '@mui/material';
import SideMenu from '../SideMenu/SideMenu';
import Header from '../Header/Header';
import {themeColors} from '../../theme/Theme';
import {useLocalStorage} from '../../hooks/useLocalStorage';
import {ErrorPage} from '../../pages/ErrorPage';

export const LayoutRoot = styled('div')(() => ({
  display: 'flex',
  height: '100%',
  maxHeight: '100%',
  overflow: 'hidden',
  width: '100%',
}));

export const LayoutWrapper = styled('div')(({theme}) => ({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
  paddingTop: 64,
  maxHeight: '100%',
}));

export const LayoutContent = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  flexDirection: 'column',
  overflow: 'auto',
  maxHeight: '100%',
  paddingLeft: '1rem',
});

export const Divide: React.FC = () => {
  return (
    <>
      <Box mt={3} />
      <Box pt={3} borderTop={`1px solid ${themeColors.greyLight}`} />
    </>
  );
};

function Layout(props: {children: React.ReactNode}) {
  const {children} = props;

  const [isSideMenuOpen, setIsSideMenuOpen] = useLocalStorage<boolean>(
    'isSideMenuOpen',
    true
  );
  const [thisNetworkErrorEvent, setThisNetworkErrorEvent] = useState<
    CustomEvent | undefined
  >(undefined);

  const handleNetworkErrorEvent = (e: Event) => {
    setThisNetworkErrorEvent(e as CustomEvent);
  };

  useEffect(() => {
    window.addEventListener('networkErrorEvent', handleNetworkErrorEvent);
    // cleanup this component
    return () => {
      window.removeEventListener('networkErrorEvent', handleNetworkErrorEvent);
    };
  }, []);

  return (
    <LayoutRoot id="layout-root">
      <Header setIsSideMenuOpen={setIsSideMenuOpen} />
      {isSideMenuOpen && !thisNetworkErrorEvent && <SideMenu />}
      {!thisNetworkErrorEvent && (
        <LayoutWrapper
          id="layout-wrapper"
          style={{paddingLeft: isSideMenuOpen ? '210px' : 0}}
        >
          <LayoutContent id="layout-content">
            <Box
              id="inner-layout-content"
              style={{margin: '0', maxHeight: '100%'}}
              pb={3}
              pr={3}
              pt={3}
            >
              {children}
            </Box>
          </LayoutContent>
        </LayoutWrapper>
      )}
      {!!thisNetworkErrorEvent && (
        <ErrorPage
          code={thisNetworkErrorEvent.detail?.statusCode}
          text={thisNetworkErrorEvent.detail?.response?.statusText}
          refresh
        />
      )}
    </LayoutRoot>
  );
}

export const FixedFooter: React.FC<BoxProps> = ({children, ...props}) => {
  return (
    <Box
      id="fixed-footer"
      position="fixed"
      bottom="0"
      zIndex={1001}
      bgcolor={themeColors.pageBackgroundColor}
      right="0"
      left="200px"
      paddingBottom={3}
      paddingLeft={3}
      paddingRight={3}
      paddingTop={1}
      {...props}
    >
      {children}
    </Box>
  );
};

export default Layout;
